/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Account_Billing_ContentInputs */

const en_help_account_billing_content = /** @type {(inputs: Help_Account_Billing_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your subscription, purchase credit packs, change your plan, or cancel anytime from Settings. Credit packs never expire and are consumed before subscription credits.`)
};

const de_help_account_billing_content = /** @type {(inputs: Help_Account_Billing_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten Sie Ihr Abonnement, kaufen Sie Kreditpakete, wechseln Sie Ihren Tarif oder kündigen Sie jederzeit in den Einstellungen. Kreditpakete verfallen nie und werden vor Abonnement-Credits verbraucht.`)
};

const fr_help_account_billing_content = /** @type {(inputs: Help_Account_Billing_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérez votre abonnement, achetez des packs de crédits, changez de forfait ou résiliez à tout moment depuis les Paramètres. Les packs de crédits n'expirent jamais.`)
};

const es_help_account_billing_content = /** @type {(inputs: Help_Account_Billing_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione su suscripción, compre paquetes de créditos, cambie de plan o cancele en cualquier momento desde Ajustes. Los paquetes de créditos no caducan.`)
};

const it_help_account_billing_content = /** @type {(inputs: Help_Account_Billing_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci il tuo abbonamento, acquista pacchetti crediti, cambia piano o annulla in qualsiasi momento dalle Impostazioni. I pacchetti crediti non scadono.`)
};

const nl_help_account_billing_content = /** @type {(inputs: Help_Account_Billing_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheer uw abonnement, koop kredietpakketten, wijzig uw plan of annuleer op elk moment via Instellingen. Kredietpakketten verlopen nooit.`)
};

const pl_help_account_billing_content = /** @type {(inputs: Help_Account_Billing_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj subskrypcją, kupuj pakiety kredytów, zmień plan lub anuluj w dowolnym momencie w Ustawieniach. Pakiety kredytów nie wygasają.`)
};

const fi_help_account_billing_content = /** @type {(inputs: Help_Account_Billing_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallitse tilaustasi, osta krediittipaketteja, vaihda suunnitelmaa tai peru milloin tahansa Asetuksista. Krediittipaketit eivät vanhene.`)
};

const da_help_account_billing_content = /** @type {(inputs: Help_Account_Billing_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrer dit abonnement, køb kreditpakker, skift plan, eller opsig når som helst fra Indstillinger. Kreditpakker udløber aldrig.`)
};

const sv_help_account_billing_content = /** @type {(inputs: Help_Account_Billing_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantera din prenumeration, köp kreditpaket, byt plan eller avbryt när som helst från Inställningar. Kreditpaket löper aldrig ut.`)
};

/**
* | output |
* | --- |
* | "Manage your subscription, purchase credit packs, change your plan, or cancel anytime from Settings. Credit packs never expire and are consumed before subscri..." |
*
* @param {Help_Account_Billing_ContentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const help_account_billing_content = /** @type {((inputs?: Help_Account_Billing_ContentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Account_Billing_ContentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_help_account_billing_content(inputs)
	if (locale === "fr") return fr_help_account_billing_content(inputs)
	if (locale === "es") return es_help_account_billing_content(inputs)
	if (locale === "it") return it_help_account_billing_content(inputs)
	if (locale === "nl") return nl_help_account_billing_content(inputs)
	if (locale === "pl") return pl_help_account_billing_content(inputs)
	if (locale === "fi") return fi_help_account_billing_content(inputs)
	if (locale === "da") return da_help_account_billing_content(inputs)
	if (locale === "sv") return sv_help_account_billing_content(inputs)
	return en_help_account_billing_content(inputs)
});